/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiRichTextEditor_ImageUploadTooLargeSubEvent} from "./UiRichTextEditorConfig"
import {UiRichTextEditor_ImageUploadStartedSubEvent} from "./UiRichTextEditorConfig"
import {UiRichTextEditor_ImageUploadSuccessfulSubEvent} from "./UiRichTextEditorConfig"
import {UiRichTextEditor_ImageUploadFailedSubEvent} from "./UiRichTextEditorConfig"
import {UiLabel_ClickedSubEvent} from "./UiLabelConfig"


import {UiFileField_FileUploadedSubEvent} from "./UiFileFieldConfig"
import {UiFileField_FileUploadErrorSubEvent} from "./UiFileFieldConfig"
import {UiFileField_FileClickedSubEvent} from "./UiFileFieldConfig"
import {UiFileField_FileRemoveButtonClickedSubEvent} from "./UiFileFieldConfig"


import {UiComboBox_LazyChildDataRequestedSubEvent} from "./UiComboBoxConfig"

import {UiTextInputHandlingField_TextInputSubEvent} from "./UiTextInputHandlingFieldConfig"
import {UiTextInputHandlingField_SpecialKeyPressedSubEvent} from "./UiTextInputHandlingFieldConfig"
import {UiSpecialKey} from "./UiSpecialKey";

export class SubEventFactory {

	    public static createUiRichTextEditor_ImageUploadTooLargeSubEvent(fileName: string, mimeType: string, sizeInBytes: number): UiRichTextEditor_ImageUploadTooLargeSubEvent {
	        return {
	            _type: "UiRichTextEditor.imageUploadTooLarge",
	            fileName: fileName,
	            mimeType: mimeType,
	            sizeInBytes: sizeInBytes
	        };
	    }public static createUiRichTextEditor_ImageUploadStartedSubEvent(fileName: string, mimeType: string, sizeInBytes: number, incompleteUploadsCount: number): UiRichTextEditor_ImageUploadStartedSubEvent {
	        return {
	            _type: "UiRichTextEditor.imageUploadStarted",
	            fileName: fileName,
	            mimeType: mimeType,
	            sizeInBytes: sizeInBytes,
	            incompleteUploadsCount: incompleteUploadsCount
	        };
	    }public static createUiRichTextEditor_ImageUploadSuccessfulSubEvent(fileUuid: string, name: string, mimeType: string, sizeInBytes: number, incompleteUploadsCount: number): UiRichTextEditor_ImageUploadSuccessfulSubEvent {
	        return {
	            _type: "UiRichTextEditor.imageUploadSuccessful",
	            fileUuid: fileUuid,
	            name: name,
	            mimeType: mimeType,
	            sizeInBytes: sizeInBytes,
	            incompleteUploadsCount: incompleteUploadsCount
	        };
	    }public static createUiRichTextEditor_ImageUploadFailedSubEvent(name: string, mimeType: string, sizeInBytes: number, incompleteUploadsCount: number): UiRichTextEditor_ImageUploadFailedSubEvent {
	        return {
	            _type: "UiRichTextEditor.imageUploadFailed",
	            name: name,
	            mimeType: mimeType,
	            sizeInBytes: sizeInBytes,
	            incompleteUploadsCount: incompleteUploadsCount
	        };
	    }
	    public static createUiLabel_ClickedSubEvent(): UiLabel_ClickedSubEvent {
	        return {
	            _type: "UiLabel.clicked",
	        };
	    }


	    public static createUiFileField_FileUploadedSubEvent(fileUuid: string, name: string, mimeType: string, sizeInBytes: number): UiFileField_FileUploadedSubEvent {
	        return {
	            _type: "UiFileField.fileUploaded",
	            fileUuid: fileUuid,
	            name: name,
	            mimeType: mimeType,
	            sizeInBytes: sizeInBytes
	        };
	    }public static createUiFileField_FileUploadErrorSubEvent(name: string, mimeType: string, sizeInBytes: number): UiFileField_FileUploadErrorSubEvent {
	        return {
	            _type: "UiFileField.fileUploadError",
	            name: name,
	            mimeType: mimeType,
	            sizeInBytes: sizeInBytes
	        };
	    }public static createUiFileField_FileClickedSubEvent(buttonData: any): UiFileField_FileClickedSubEvent {
	        return {
	            _type: "UiFileField.fileClicked",
	            buttonData: buttonData
	        };
	    }public static createUiFileField_FileRemoveButtonClickedSubEvent(buttonData: any): UiFileField_FileRemoveButtonClickedSubEvent {
	        return {
	            _type: "UiFileField.fileRemoveButtonClicked",
	            buttonData: buttonData
	        };
	    }


	    public static createUiComboBox_LazyChildDataRequestedSubEvent(parentId: any): UiComboBox_LazyChildDataRequestedSubEvent {
	        return {
	            _type: "UiComboBox.lazyChildDataRequested",
	            parentId: parentId
	        };
	    }

	    public static createUiTextInputHandlingField_TextInputSubEvent(enteredString: string): UiTextInputHandlingField_TextInputSubEvent {
	        return {
	            _type: "UiTextInputHandlingField.textInput",
	            enteredString: enteredString
	        };
	    }public static createUiTextInputHandlingField_SpecialKeyPressedSubEvent(key: UiSpecialKey): UiTextInputHandlingField_SpecialKeyPressedSubEvent {
	        return {
	            _type: "UiTextInputHandlingField.specialKeyPressed",
	            key: key
	        };
	    }

}